import { render, staticRenderFns } from "./ListDetails.vue?vue&type=template&id=0fb72c25"
import script from "./ListDetails.vue?vue&type=script&lang=js"
export * from "./ListDetails.vue?vue&type=script&lang=js"
import style0 from "./ListDetails.vue?vue&type=style&index=0&id=0fb72c25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports